import * as Scrivito from "scrivito"

export const FeatureWidget = Scrivito.provideWidgetClass("FeatureWidget", {
  attributes: {
    topHeadline: "string",
    headline: ["widgetlist", { only: "TextWidget", maximum: 1 }],
    text: ["widgetlist", { only: "TextWidget", maximum: 1 }],
    image: ["reference", { only: "Image" }],
    imageWidgets: ["widgetlist", { only: "ImageWidget" }],
    objectFit: ["enum", { values: ["image-cover", "image-contain"] }],
    buttons: ["widgetlist", { only: ["ButtonWidget", "LoginButtonWidget"] }],
    alternativeBackground: "boolean",
    elementId: "string"
  }
})
